import { Form, Input, Select } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MPageHeader from "../../../../component/PageHeader";
import { documentService } from "../service/document.service";
import { DocumentCategory, DocumentUI } from "../entity/document.model";
import { dialog } from "../../../../helper/dialog";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { fileService } from "../../shared/service/file.service";
import { mConstants } from "../../../../helper/constants";
import MUploadImage from "../../../../component/UploadImage";
import { FileResponse } from "../../customer/entity/customer.model";
import helper from "../../../../helper/helper";

const { Option } = Select;

function EditDocument() {
  const [form] = useForm();
  let navigate = useNavigate();
  let { documentId } = useParams();
  const [document, setDocument] = useState<DocumentUI>();
  const [categories, setCategories] = useState<DocumentCategory[]>([]);
  const [editorValue, setEditorValue] = useState<string>("");

  useEffect(() => {
    if (documentId) {
      documentService.getDocument(documentId).then((_document) => {
        if (_document.mainImagePath) {
          helper.getPublicImage(_document.mainImagePath).then((file) => {
            setDocument({
              ..._document,
              image: file,
            });
            form.setFieldsValue({ ..._document, image: file });
          });
        } else {
          setDocument(_document);
          form.setFieldsValue(_document);
        }

        setEditorValue(_document.content);
      });
    }

    documentService.getDocumentCategories().then((_categories) => {
      setCategories(_categories);
    });
  }, [documentId]);

  const onFinish = async (value: DocumentUI) => {
    value = { ...document, ...value };
    value.content = editorValue;

    if (value.image && value.image.name) {
      await fileService
        .uploadFile(value.image, true)
        .then((fileReponse: FileResponse) => {
          value.mainImagePath = fileReponse.fileName;
        });
    }

    if (documentId) {
      value.uuid = documentId;
      await documentService.editDocument(value);
      dialog.success("Документ амжилттай заслаа.");
    } else {
      await documentService.addDocument(value);
      dialog.success("Документ амжилттай нэмлээ.");
    }

    navigate("/documents");
  };

  function uploadAdapter(loader: any) {
    return {
      upload: () => {
        return loader.file.then(async (file: File) => {
          const fileResponse = await fileService.uploadFile(file, true);

          return {
            default:
              mConstants.API_URL +
              mConstants.PUBLIC_FILE_DOWNLOAD_PATH +
              fileResponse.fileName,
          };
        });
      },
    };
  }
  function uploadPlugin(editor: any) {
    editor.plugins.get("FileRepository").createUploadAdapter = (
      loader: any
    ) => {
      return uploadAdapter(loader);
    };
  }

  return (
    <>
      <MPageHeader crumbs={["Төлөвлөгөө"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Документ мэдээлэл</h6>
          </div>
          <div className="card-body">
            <Form form={form} onFinish={onFinish}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Гарчиг<span className="text-danger">*</span>
                    </label>
                    <Form.Item
                      name="title"
                      rules={[
                        {
                          required: true,
                          message: "Гарчигийг оруулна уу.",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      Линк<span className="text-danger">*</span>
                    </label>
                    <Form.Item name="link" rules={[{ required: true, message: "Линк оруулна уу." }]}>
                      <Input />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Ангилал<span className="text-danger">*</span>
                    </label>
                    <Form.Item
                      name={["documentCategory", "uuid"]}
                      rules={[
                        {
                          required: true,
                          message: "Ангилалыг сонгоно уу.",
                        },
                      ]}
                    >
                      <Select placeholder="Ангилал сонгох">
                        {categories.map((x, i) => (
                          <Option key={i} value={x.uuid}>
                            {x.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>
                  Үндсэн зураг<span className="text-danger">*</span>
                </label>

                <Form.Item
                  name="image"
                  rules={[
                    {
                      required: true,
                      message: "Үндсэн зураг оруулна уу.",
                    },
                  ]}
                >
                  <MUploadImage />
                </Form.Item>
              </div>

              <label>
                Агуулга<span className="text-danger">*</span>
              </label>

              <div
                style={{
                  borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                  minHeight: "300px",
                }}
                className="mb-5"
              >
                <CKEditor
                  editor={ClassicEditor}
                  data={editorValue}
                  config={{
                    extraPlugins: [uploadPlugin],
                  }}
                  onChange={(_: any, editor: any) => {
                    const data = editor.getData();
                    setEditorValue(data);
                  }}
                />
              </div>
              <div className="text-right">
                <button type="submit" className="btn btn-primary">
                  Хадгалах <i className="icon-floppy-disk ml-2" />
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditDocument;
